import { useEffect, useState } from 'react';
import { Button, Center, Spinner, Stack, Text } from '@chakra-ui/react';
import { LuCircleCheck, LuCircleX } from 'react-icons/lu';
import { Link as RouterLink, useParams } from 'react-router';
import { confirmEmailService } from '@/services/auth';

type Status = 'loading' | 'success' | 'error';

const ConfirmEmail = () => {
  const { token } = useParams<{ token: string }>();
  const [status, setStatus] = useState<Status>(() => (token ? 'loading' : 'error'));
  const [errorMessage, setErrorMessage] = useState<string>(() =>
    token ? '' : 'Token inválido.',
  );

  useEffect(() => {
    if (!token) return;

    confirmEmailService(token)
      .then(() => setStatus('success'))
      .catch((err) => {
        setErrorMessage(
          err?.response?.data?.message ?? 'Não foi possível confirmar o e-mail. Tente novamente.',
        );
        setStatus('error');
      });
  }, [token]);

  return (
    <Center minH="100vh" px="4">
      <Stack align="center" gap="6" maxW="sm" textAlign="center">
        {status === 'loading' && (
          <>
            <Spinner size="xl" color="primary.500" />
            <Text color="fg.muted">Confirmando seu e-mail...</Text>
          </>
        )}

        {status === 'success' && (
          <>
            <LuCircleCheck size={56} color="var(--chakra-colors-green-500)" />
            <Stack gap="2">
              <Text fontWeight="semibold" fontSize="lg">E-mail confirmado!</Text>
              <Text color="fg.muted" fontSize="sm">
                Sua conta foi ativada com sucesso. Você já pode fazer login.
              </Text>
            </Stack>
            <Button asChild>
              <RouterLink to="/">Ir para o login</RouterLink>
            </Button>
          </>
        )}

        {status === 'error' && (
          <>
            <LuCircleX size={56} color="var(--chakra-colors-red-500)" />
            <Stack gap="2">
              <Text fontWeight="semibold" fontSize="lg">Falha na confirmação</Text>
              <Text color="fg.muted" fontSize="sm">{errorMessage}</Text>
            </Stack>
          </>
        )}
      </Stack>
    </Center>
  );
};

export default ConfirmEmail;
